import { Grid } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { WalletSelectOptionRendererProps } from './types';
import { obscureAccountNo } from '../helpers/stringHelpers';

const WalletSelectOptionRendererComponent = React.forwardRef((props: WalletSelectOptionRendererProps, ref) => {
    const {
        innerProps,
        innerRef,
        getValue,
        data
    } = props;

    const classes = muiStyles(props);

    const optionRef = React.useRef<any>(innerRef);
    const wallet = data.refData;
    const currentValue = getValue().length === 1 && getValue()[0].value;
    let selected = false;
    if (currentValue === wallet.AccountId) {
        selected = true;
    }

    return (
        <Grid
            className={`${classes.root} ${selected ?
                classes.selected
                : classes.hover}`}
            container
            direction='column'
            ref={optionRef}
            spacing={0}
            wrap='nowrap'
            {...innerProps}
        >
            <div className={classes.walletOptionSelectWrapper}>
                <div className={classes.walletOptionSelect}>
                    <div className={`${classes.walletOptionSelect}__left`}>
                        <div>{wallet.WalletName1}</div>
                        <div>{wallet.WalletName2}</div>
                    </div>
                    <div className={`${classes.walletOptionSelect}__right`}>
                        <div>{obscureAccountNo(wallet.Account)}</div>
                    </div>
                </div>
            </div>
        </Grid>
    );
});

WalletSelectOptionRendererComponent.displayName = 'WalletSelectOptionRendererComponent';
export default WalletSelectOptionRendererComponent;